import "./LabTestAndPanelViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../../shared/services";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../../../constants";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import LabTestAndPanelViewComponent from "./lab-test-and-panel-view/LabTestAndPanelViewComponent";
import LabTestAndPanelEditComponent from "./lab-test-and-panel-edit/LabTestAndPanelEditComponent";

interface LabTestAndPanelViewEditComponentProps {
    labID: any;
    canEdit: boolean;
    onModeChange: (mode: string) => void;
}

const LabTestAndPanelViewEditComponent = (props: LabTestAndPanelViewEditComponentProps) => {
    const {labID, canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [isLabTestAndPanelLoading, setIsLabTestAndPanelLoading] = useState<boolean>(false);
    const [labTestAndPanel, setLabTestAndPanel] = useState<any>(undefined);
    const [isLabTestAndPanelLoaded, setIsLabTestAndPanelLoaded] = useState<boolean>(false);
    const [isLabTestAndPanelLoadingFailed, setIsLabTestAndPanelLoadingFailed] = useState<boolean>(false);

    const handleGetLabTestAndPanel = useCallback((labID: string) => {
        const payload = {}
        setIsLabTestAndPanelLoading(true);
        setIsLabTestAndPanelLoaded(false);
        setIsLabTestAndPanelLoadingFailed(false);
        CommonService._lab.getLabTestAndPanels(labID, payload)
            .then((res: any) => {
                setIsLabTestAndPanelLoading(false);
                setIsLabTestAndPanelLoaded(true);
                setIsLabTestAndPanelLoadingFailed(false);
                setLabTestAndPanel(res?.data);
            })
            .catch((err: any) => {
                setIsLabTestAndPanelLoading(false);
                setIsLabTestAndPanelLoaded(true);
                setIsLabTestAndPanelLoadingFailed(false);
                setLabTestAndPanel(undefined);
            })
    }, []);

    useEffect(() => {
        handleGetLabTestAndPanel(labID);
    }, [labID,handleGetLabTestAndPanel]);

    const handleLabTestAndPanelEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    const handleLabAndTestPanelUpdate = useCallback(() => {
        handleGetLabTestAndPanel(labID);
        setMode("view");
    }, [labID,handleGetLabTestAndPanel]);

    return (
        <div className={'lab-test-and-panel-view-edit-component details-tab-data-wrapper'}>
            {
                isLabTestAndPanelLoading && <div className="details-screen-loading-icon h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                isLabTestAndPanelLoadingFailed && <div className="bg-color-white">
                    <StatusCardComponent title={"Lab Attachments failed to load"}/>
                </div>
            }
            {
                isLabTestAndPanelLoaded &&
                <>
                    {
                        mode === "view" && <LabTestAndPanelViewComponent
                            labTestAndPanel={labTestAndPanel}
                            canEdit={canEdit}
                            onEditModeOpen={(testAndPanel:any) => {
                                setLabTestAndPanel(testAndPanel)
                                setMode("edit")
                            }}
                        />
                    }
                    {
                        mode === "edit" && <LabTestAndPanelEditComponent
                            onEditCancel={() => {
                                handleLabTestAndPanelEditCancel()
                            }}
                            labID={labID}
                            labTestAndPanel={labTestAndPanel}
                            canEdit={canEdit}
                            onUpdateComplete={handleLabAndTestPanelUpdate}
                        />
                    }
                </>
            }
        </div>
    );

};

export default LabTestAndPanelViewEditComponent;